import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'where_active_soa_2.title1',
    defaultMessage: 'Which online store do you wish to buy from?',
  },
});
